import { useApi } from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';
import {
  NotificationApi,
  notificationApiRef,
} from '../../../../apis/notificationApi';
import { permitBuildApiRef } from '../../../../apis/permitToBuildApi';

export const useGetAllTickets = (shouldcall: boolean) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);
  const permitBuildApi = useApi(permitBuildApiRef);

  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [callCounter, setCallCounter] = useState<number>(Number(shouldcall));

  const getAllTickets = async () => {
    setLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.getAllTickets();
        setLoading(false);
        if (response) {
          setTickets(response);
        }
      } catch (error) {
        setLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const refreshTickets = () => {
    setCallCounter(prevState => prevState + 1);
  };

  useEffect(() => {
    if (callCounter) getAllTickets();
  }, [callCounter]);

  return {
    tickets,
    refreshTickets,
    loading,
  } as const;
};
